import { ReactNode } from 'react';
import { clsx } from 'clsx';

interface GlassPanelProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
}

export function GlassPanel({ children, className, hover = false }: GlassPanelProps) {
  return (
    <div
      className={clsx(
        hover ? 'glass-panel-hover' : 'glass-panel',
        className
      )}
    >
      {children}
    </div>
  );
}
